<div mat-dialog-content>
    <div class="head-exam-type-modal-list">
        <h2>Salvar Favorito (Externa)</h2>
    </div>

    <form class="form" [formGroup]="model" (ngSubmit)="clickSave()">
        <div class="mat-dialog-content" style="padding-top: 15px;">
            <div class="row">
                <div class="col-12 col-sm-12 col-md-12">
                    <mat-form-field appearance="outline">
                        <mat-label>Nome do Favorito</mat-label>
                        <input matInput formControlName="favoriteName" placeholder="Ex: Analgesia" maxlength="150">
                    </mat-form-field>
                </div>
            </div>

            <app-loading-list *ngIf="loading"></app-loading-list>

            <div class="footer-panel-modal-list">
                <div class="row">
                    <div class="col-6">
                        <a mat-flat-button color="accent" class="btn-block" (click)="clickCancel()">Cancelar</a>
                    </div>
                    <div class="col-6">
                        <button mat-flat-button type="submit" color="primary" class="btn-block" [disabled]="loading">
                            Salvar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>